import React              from 'react';
import { useTranslation } from 'react-i18next';

import { useSiteSettings } from '../../providers/siteSettings';

const ContactsList = function() {
  const {
          data: {
                  CONTACTS: {
                              EMAIL    = [],
                              PHONE    = [],
                              TELEGRAM = [],
                              VIBER    = [],
                              WHATSAPP = [],
                            },
                },
        }     = useSiteSettings();
  const { t } = useTranslation();

  return (
    <div className={'list'}>
      <div>
        {PHONE.map(({
          signature,
          value,
        }, i) => value ? (
          <span key={i}>{signature || t('client_default_phone_label')}</span>
        ) : null)}
        {EMAIL.map(({
          signature,
          value,
        }, i) => value ? (
          <span key={i}>{signature || 'E-mail'}</span>
        ) : null)}
        {VIBER.map(({
          signature,
          value,
        }, i) => value ? (
          <span key={i}>{signature || 'Viber'}</span>
        ) : null)}
        {WHATSAPP.map(({
          signature,
          value,
        }, i) => value ? (
          <span key={i}>{signature || 'WhatsApp'}</span>
        ) : null)}
        {TELEGRAM.map(({
          signature,
          value,
        }, i) => value ? (
          <span key={i}>{signature || 'Telegram'}</span>
        ) : null)}
      </div>
      <div>
        {PHONE.map(({
          signature,
          value,
        }, i) => value ? (
          <a href={`tel:${value}`} key={i}>{value}</a>
        ) : null)}
        {EMAIL.map(({
          signature,
          value,
        }, i) => value ? (
          <a href={`mailto:${value}`} key={i}>{value}</a>
        ) : null)}
        {VIBER.map(({
          signature,
          value,
        }, i) => value ? (
          <a
            href={`viber://chat?number=${value}`}
            key={i}
            rel={'nofollow'}
            target={'_blank'}
          >{value}</a>
        ) : null)}
        {WHATSAPP.map(({
          signature,
          value,
        }, i) => value ? (
          <a
            href={`https://wa.me/${value.replace(/\D/gi, '')}`}
            key={i}
            rel={'nofollow'}
            target={'_blank'}
          >{value}</a>
        ) : null)}
        {TELEGRAM.map(({
          signature,
          value,
        }, i) => value ? (
          <a
            href={`tg://resolve?domain=${value}`}
            key={i}
            rel={'nofollow'}
            target={'_blank'}
          >{value}</a>
        ) : null)}
      </div>
    </div>
  );
};

export default ContactsList;